// import MachineImg from "../../assets/Images/machineImg.svg";

import { useCallback, useState } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";

// const MachineDetails = () => {
//   return (
//     <div>
//       <div>
//         <img src={MachineImg} alt="" width={"100%"} />
//       </div>
//       <div className="shadow-xl bg-white p-[10px]">
//         <div className="text-[#161412] font-bold text-[28px] leading-[27px]">2016 Roadtec SB-2500e</div>
//         <div className="text-[#161412] font-normal text-[20px] leading-[27px]">Material Transfer Vehicle</div>
//         <div className="text-[#161412] font-medium text-[20px] leading-[27px]">2425 Hours</div>

//         <div
//           className="
//   border-y border-gray-200 my-2 py-3 flex flex-wrap
//   justify-between sm:justify-start sm:space-x-4
// "
//         >
//           <div className="text-gray-800 font-medium text-sm sm:text-base pr-2 sm:pr-4">
//             Location: Anycity, USA 12345
//           </div>
//           <div className="text-gray-800 font-medium text-sm sm:text-base border-x border-gray-800 px-2 sm:px-4">
//             SN: 2056
//           </div>
//           <div className="text-gray-800 font-medium text-sm sm:text-base pl-2 sm:pl-4">Unit #: 1423-254F</div>
//         </div>

//         <div>
//           <div className="text-[#161412] font-bold font-[20px] mt-[10px]">Details:</div>
//           <div className="text-[#161412] font-medium font-[16px]">Auto Lube</div>
//           <div className="text-[#161412] font-medium font-[16px]">2 Tires - 30%</div>
//           <div className="text-[#161412] font-medium font-[16px]">2 Tires - 60%</div>
//           <div className="text-[#161412] font-medium font-[16px]">C-1 Chain 70%</div>
//           <div className="text-[#161412] font-medium font-[16px]">C-1 Augers 40%</div>
//           <div className="text-[#161412] font-medium font-[16px]">C-2 Chain 70%</div>
//           <div className="text-[#161412] font-medium font-[16px]">C-3 Chain 50%</div>
//         </div>

//         <div className="grid gap-4 mt-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//           <div>
//             <img src={MachineImg} alt="" width={"100%"} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default MachineDetails;

// Back Up code
// import { ImageGroup, Image } from "react-fullscreen-image"; // remove this package

const MachineDetails = ({ images, data, isLoading }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [selectedMainImage, setSelectedMainImage] = useState(0);

  // Open preview modal
  const openPreview = (image, index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const handleThumbnailClick = (index) => {
    setSelectedMainImage(index);
  };

  const handlePrevImage = () => {
    setSelectedMainImage((prev) => (prev === 0 ? ImgList.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setSelectedMainImage((prev) => (prev === ImgList.length - 1 ? 0 : prev + 1));
  };

  if (isLoading) {
    return (
      <div>
        <div className="animate-pulse">
          {/* Image Skeleton */}
          <div className="bg-gray-300 h-64 w-full rounded-t-lg"></div>

          {/* Details Skeleton */}
          <div className="shadow-xl bg-white p-[10px]">
            <div className="h-8 bg-gray-300 rounded mb-4"></div>
            <div className="h-6 bg-gray-300 rounded mb-2"></div>
            <div className="h-6 bg-gray-300 rounded mb-2"></div>

            {/* Horizontal Section */}
            <div className="flex flex-wrap justify-between sm:justify-start sm:space-x-4 border-y border-gray-200 my-2 py-3">
              <div className="h-6 bg-gray-300 rounded w-32"></div>
              <div className="h-6 bg-gray-300 rounded w-24"></div>
              <div className="h-6 bg-gray-300 rounded w-20"></div>
            </div>

            {/* Notes Section */}
            <div>
              <div className="h-6 bg-gray-300 rounded w-40 mt-[10px] mb-2"></div>
              <div className="h-4 bg-gray-300 rounded w-full"></div>
              <div className="h-4 bg-gray-300 rounded w-3/4 mt-1"></div>
            </div>

            {/* Images Skeleton */}
            <div className="grid gap-4 mt-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              {[...Array(8)].map((_, index) => (
                <div key={index} className="bg-gray-300 h-32 rounded"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const ImgList = images
    ?.filter((item) => item?.image)
    ?.map((item) => {
      return {
        ...item,
        src: item?.image,
        srcset: item.srcSet,
        caption: item.title,
      };
    });

  const mainImage = ImgList?.[selectedMainImage] || { src: data?.primary_image?.url };

  return (
    <div>
      {/* Main Gallery Section */}
      <div className="relative">
        {/* Main Image with Navigation */}
        <div className="relative group">
          <img
            src={mainImage?.src || data?.primary_image?.url}
            alt="Main view"
            className="rounded-t-lg max-h-[550px] min-h-[400px] w-full object-cover object-center cursor-pointer"
            onClick={() => openPreview(mainImage, selectedMainImage)}
          />

          {/* Navigation Arrows */}
          {ImgList?.length > 1 && (
            <>
              <button
                onClick={handlePrevImage}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                aria-label="Previous image"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button
                onClick={handleNextImage}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                aria-label="Next image"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </>
          )}

          {/* Image Counter */}
          {ImgList?.length > 0 && (
            <div className="absolute bottom-4 right-4 bg-black bg-opacity-60 text-white px-3 py-1 rounded-full text-sm">
              {selectedMainImage + 1} / {ImgList.length}
            </div>
          )}
        </div>

        {/* Thumbnail Strip */}
        {ImgList?.length > 1 && (
          <div className="mt-4 px-2">
            <div className="flex gap-2 overflow-x-auto pb-2">
              {ImgList.map((item, index) => (
                <button
                  key={index}
                  onClick={() => handleThumbnailClick(index)}
                  className={`flex-shrink-0 relative rounded-lg overflow-hidden transition-all duration-200 ${selectedMainImage === index
                    ? 'ring-4 ring-[#FEBA06] scale-105'
                    : 'opacity-70 hover:opacity-100'
                    }`}
                >
                  <img
                    src={item.src}
                    alt={`Thumbnail ${index + 1}`}
                    className="h-20 w-28 object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="shadow-xl bg-white p-[10px]">
        <div className="text-[#161412] font-bold text-[28px] leading-[27px]  break-words">
          {data?.year}&nbsp;
          {data?.model?.manufacturer?.name}&nbsp;
          {data?.model?.number}&nbsp;
        </div>
        <div className="text-[#161412] font-normal text-[20px] leading-[27px] break-words">
          {data?.machine_type?.name}
        </div>
        <div className="text-[#161412] font-medium text-[20px] leading-[27px]">
          {data?.meter_reading ? data?.meter_reading : "N/A"}{" "}
          {data?.meter_reading_unit ? data?.meter_reading_unit : "Hours"}
        </div>

        <div
          className="
  border-y border-gray-200 my-2 py-3 flex flex-wrap
  justify-between sm:justify-start sm:space-x-4
"
        >
          <div className="text-gray-800 font-medium text-sm sm:text-base pr-2 sm:pr-4">
            Location: {data?.location !== " " ? data?.location : "N/A"}
          </div>
          <div className="text-gray-800 font-medium text-sm sm:text-base border-x border-gray-800 px-2 sm:px-4">
            SN: {data?.assetAdvertisementId}
          </div>
          <div className="text-gray-800 font-medium text-sm sm:text-base pl-2 sm:pl-4">Unit #: {data?.unit_number}</div>
        </div>

        <div>
          <div className="text-[#161412] font-bold text-[20px] mt-[10px]">Details:</div>
          <div className="text-[#161412] font-medium text-[16px]">{data?.notes}</div>
        </div>

        {/* Additional Images Grid - Hidden since we have gallery above */}
        {/* <div className="grid gap-4 mt-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {ImgList?.map((item, index) => {
            return item?.image ? (
              <div key={index} className="relative group border rounded-lg overflow-hidden my-[10px]">
                <div key={index}>
                  <img src={item?.image} alt="" width={"100%"} className="rounded-t-lg object-cover h-[150px]" />
                </div>

                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <button
                    className="text-white text-sm bg-gray-700 py-1 px-3 rounded hover:bg-gray-800"
                    onClick={() => openPreview(item?.image, index)}
                  >
                    Preview
                  </button>
                </div>
              </div>
            ) : null;
          })}
        </div> */}

        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={closeLightbox}>
              <Carousel currentIndex={currentImage} views={ImgList} styles={{ margin: "auto" }} />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
    </div>
  );
};
export default MachineDetails;
